import config from 'src/common/config';
import isWindowsDesktop from 'src/common/utils/userAgent/isWindowsDesktop.js';
export default function getConfigStreamFormats(isMobile, isDesktop, userAgent) {
  let formats = config.streamFormats;

  if (isMobile) {
    formats = config.mobileStreamFormats;
  }

  if (isDesktop) {
    formats = config.desktopStreamFormats;
  }

  if (!isWindowsDesktop(userAgent)) {
    formats = formats.replace(',wma', '');
  }

  return formats;
}
